import { useLocation } from 'react-router-dom';

import config from 'config';

export const useUrlTrackingParams = (link: string) => {
  const location = useLocation();
  const path = location.pathname.replace('/', '');
  const trackingParams = `utm_source=portal_${config.app.short}&utm_medium=${path}`;
  if (link.includes('?')) {
    return `${link}&${trackingParams}`;
  }
  return `${link}?${trackingParams}`;
};
